/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListClusterPricesRequest = {
  model?: string | undefined;
};

/** @internal */
export const ListClusterPricesRequest$inboundSchema: z.ZodType<
  ListClusterPricesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  model: z.string().optional(),
});
/** @internal */
export type ListClusterPricesRequest$Outbound = {
  model?: string | undefined;
};

/** @internal */
export const ListClusterPricesRequest$outboundSchema: z.ZodType<
  ListClusterPricesRequest$Outbound,
  z.ZodTypeDef,
  ListClusterPricesRequest
> = z.object({
  model: z.string().optional(),
});

export function listClusterPricesRequestToJSON(
  listClusterPricesRequest: ListClusterPricesRequest,
): string {
  return JSON.stringify(
    ListClusterPricesRequest$outboundSchema.parse(listClusterPricesRequest),
  );
}
export function listClusterPricesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListClusterPricesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListClusterPricesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListClusterPricesRequest' from JSON`,
  );
}
